import type { ReactNode } from 'react'

/** Beschriftetes Eingabefeld. Das label umschliesst das Feld, deshalb braucht
 *  es keine ID und keine Verknüpfung, die auseinanderlaufen kann. */
export function Field({ label, children }: { label: string; children: ReactNode }) {
  return (
    <label className="feld">
      <span>{label}</span>
      {children}
    </label>
  )
}
